import DownloadRefundPDF from "@/components/common/RefundPDF";
import { Table, TableHead, TableRow, TableCell, TableBody, useTheme } from "@mui/material";
import { Box, Text, Accordion } from "@/ui";
import { useQueryParams } from "@/utils/useQueryParams";
import { useSystemContext } from "@/provider/common/SystemProvider";
import { formatUTC } from "@/utils/format";
import { FilterPeriodBox } from "./DateFilter";

function RefundItem({ refund }: { refund: any }) {
  const RefundHeader = () => (
    <Box flexDirection="row" justifyContent="space-between" alignItems="center" width="100%" style={{ paddingRight: 8 }}>
      <Text fontSize={14} fontWeight="600">
        {formatUTC(refund.date, "dd/MM/yyyy")} - {refund.nom_organisme}
      </Text>
      <Text fontSize={16} fontWeight="700" color="#FF008D">
        {parseFloat(refund.total).toFixed(2)} €
      </Text>
    </Box>
  );

  return (
    <Box width="100%" py={1} justifyContent="center" alignItems="center">
      <Accordion width="100%" title={`refund-${refund.remboursement_id}`} HeaderComponent={RefundHeader} boxShadow="none">
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell>Facture</TableCell>
              <TableCell>Patient</TableCell>
              <TableCell>Date</TableCell>
              <TableCell>Payé</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {refund.details_remboursements.map((detail, detailIndex) => (
              <TableRow
                key={detail.detail_id || detailIndex}
                style={{
                  backgroundColor: detailIndex % 2 === 0 ? "#fff" : "#f3e7e765",
                }}
              >
                <TableCell>{detail.num_facture}</TableCell>
                <TableCell>{detail.nom_patient || detail.factures?.nom_patient || "-"}</TableCell>
                <TableCell>
                  {formatUTC(detail.date_debut, "dd/MM/yyyy")} - {formatUTC(detail.date_fin, "dd/MM/yyyy")}
                </TableCell>
                <TableCell>{parseFloat(detail.montant_paye).toFixed(2)} €</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </Accordion>
    </Box>
  );
}

export function RefundViewCpnWeb({ refunds, pluralize }: any) {
  const theme = useTheme();
  const params = useQueryParams();
  const { getUser } = useSystemContext();

  return (
    <Box width="100%" alignItems="center" flexDirection="column" height="100%" p={5} style={{ overflowY: "scroll", overflowX: "hidden" }}>
      <FilterPeriodBox />

      {refunds?.length > 0 ? (
        <>
          <Box flexDirection="row" justifyContent="space-between" alignItems="center" width="100%" mb={2}>
            <DownloadRefundPDF data={refunds} period={params.period} currentUser={getUser()} />
            <Box flexDirection="column" alignItems="flex-end">
              <Text fontSize={20} fontWeight="700" color={theme.palette.primary.main}>
                {refunds.reduce((acc, refund) => {
                  const total = refund?.total ? parseFloat(refund.total) : 0;
                  let number = Number(acc + total).toFixed(2);
                  return Number(number);
                }, 0)}{" "}
                €
              </Text>
              {/* <Text fontSize={13} color={theme.palette.grey[600]}>
                {refunds.length} {pluralize(refunds.length, "virement", "virements")} -{" "}
                {refunds.filter((refund, index, self) => self.findIndex((r) => r.nom_organisme === refund.nom_organisme) === index).length}{" "}
                {pluralize(
                  refunds.filter((refund, index, self) => self.findIndex((r) => r.nom_organisme === refund.nom_organisme) === index).length,
                  "organisme",
                  "organismes",
                )}
              </Text> */}
            </Box>
          </Box>

          {refunds.map((refund, index) => (
            <RefundItem key={refund.remboursement_id || index} refund={refund} />
          ))}
        </>
      ) : (
        <Box justifyContent="center" alignItems="center" width="100%" p={2}>
          <Text fontSize={18} fontWeight={500}>
            Aucun remboursement pour cette période
          </Text>
        </Box>
      )}
    </Box>
  );
}
